import { handlePostRequest } from "../../services/PostTemplate";
import { handlePutRequest } from "../../services/PutTemplate";
import { handleGetRequest } from "../../services/GetTemplate";
import {
    ADDCOMPANYPROFILE_SUCCESS,
    ADDCOMPANYPROFILE_ERROR,
    GETCOMPANYDETAILS_SUCCESS,
    GETCOMPANYDETAILS_ERROR,
    GETAUTHMATRIXFURTHERDETAILS_SUCCESS,
    GETAUTHMATRIXFURTHERDETAILS_ERROR,
    SETAUTHMATRIXFURTHERDETAILS_SUCCESS,
    SETAUTHMATRIXFURTHERDETAILS_ERROR,
    SETEDITFLAG_SUCCESS,
    SETCOMPANYPRODUCTFLAG_SUCCESS,
    SETAUTHMATRIXFURTHERDETAILS_NULL_SUCCESS,
    GETPARSERHEADDETAILS_SUCCESS,
    GETPARSERHEADDETAILS_ERROR,
    SETPARSERHEADFURTHERDETAILS_SUCCESS,
    SETPARSERHEADFURTHERDETAILSDATA_SUCCESS,
    SETPARSERHEADFURTHERDETAILS_NULL_SUCCESS,
    SETCOMPANYPRODUCTFORMDATA_SUCCESS,
    SETCOMPANYPRODUCTFORMDATA_ERROR,
    SETCOMPANYPRODUCTFORMDATA_NULL_SUCCESS,
    GETCOMPANYPRODUCTDETAIL_SUCCESS,
    GETCOMPANYPRODUCTDETAIL_ERROR,
    SETCOMPANYUSERSFORMDATA_SUCCESS,
    SETCOMPANYUSERSFORMDATA_ERROR,
    SETCOMPANYUSERSFORMDATA_NULL_SUCCESS,
    SETCOMPANYUSERSFLAG_SUCCESS,
    GETCOMPANYUSERSDETAIL_SUCCESS,
    GETCOMPANYUSERSDETAIL_ERROR,
    SETCOMPANYACCOUNTFORMDATA_SUCCESS,
    SETCOMPANYACCOUNTFORMDATA_ERROR,
    SETCOMPANYACCOUNTFORMDATA_NULL_SUCCESS,
    SETCOMPANYACCOUNTFLAG_SUCCESS,
    GETCOMPANYACCOUNTDETAIL_SUCCESS,
    GETCOMPANYACCOUNTDETAIL_ERROR,
    SETCOMPANYACCOUNTANDPRODUCTFORMDATA_SUCCESS,
    SETCOMPANYACCOUNTANDPRODUCTFORMDATA_ERROR,
    SETCOMPANYACCOUNTANDPRODUCTFORMDATA_NULL_SUCCESS,
    SETCOMPANYACCOUNTANDPRODUCTFLAG_SUCCESS,
    GETCOMPANYACCOUNTANDPRODUCT_SUCCESS,
    GETCOMPANYACCOUNTANDPRODUCT_ERROR,
    SETCOMPANYGROUPFORMDATA_SUCCESS,
    SETCOMPANYGROUPFORMDATA_ERROR,
    SETCOMPANYGROUPFORMDATA_NULL_SUCCESS,
    SETCOMPANYGROUPFLAG_SUCCESS,
    GETCOMPANYGROUPDETAIL_SUCCESS,
    GETCOMPANYGROUPDETAIL_ERROR,
    GETCOMPANYACCOUNTAUTHORIZATION_SUCCESS,
    GETCOMPANYACCOUNTAUTHORIZATION_ERROR,
    GETPARSERHEADFURTHERDETAILS_SUCCESS,
    GETPARSERHEADFURTHERDETAILS_ERROR,
    GETCOMPANYPARSERLINKEDHEADDETAILS_SUCCESS,
    GETCOMPANYPARSERLINKEDHEADDETAILS_ERROR,
    SETPARSEREDITFLAG_SUCCESS,
    SETPARSERHEADDETAILSEDITFLAG_SUCCESS,
} from "../slices/companySlice";

export const AddCompanyProfileAction = (data, url) => async (dispatch) => {
    const res = await handlePostRequest(data, url);
    if (res?.responsecode === 1) {
        dispatch(ADDCOMPANYPROFILE_SUCCESS(res?.data));
        return res;
    } else {
        dispatch(ADDCOMPANYPROFILE_ERROR("Error"));
        return res;
    }
};
export const UpdateCompanyProfileAction = (data, url) => async (dispatch) => {
    const res = await handlePutRequest(data, url);
    if (res?.responsecode === 1) {
        dispatch(ADDCOMPANYPROFILE_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        return res;
    }
};
export const GetCompanyDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYDETAILS_SUCCESS(res?.data?.tblCompany));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYDETAILS_ERROR("Error"));
        return res?.responsecode;
    }
};

export const GetAuthMatrixFurtherDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        console.log(res.data);
        dispatch(GETAUTHMATRIXFURTHERDETAILS_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETAUTHMATRIXFURTHERDETAILS_ERROR("Error"));
        return res?.responsecode;
    }
};

export const SetAuthMatrixFurtherDetailsAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETAUTHMATRIXFURTHERDETAILS_SUCCESS(data));
    } else {
        dispatch(SETAUTHMATRIXFURTHERDETAILS_ERROR("Error"));
    }
};
export const SetEditFlagAction = (data) => async (dispatch) => {
    dispatch(SETEDITFLAG_SUCCESS(data));
};

//COMPANY PRODUCT FLAG   SETCOMPANYPRODUCTFLAG
export const SetEditCompanyProductFlagAction = (data) => async (dispatch) => {
    dispatch(SETCOMPANYPRODUCTFLAG_SUCCESS(data));
};
//COMPANY PRODCUT FORM DATA
export const SetCompanyProductFormDataAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETCOMPANYPRODUCTFORMDATA_SUCCESS(data));
    } else {
        dispatch(SETCOMPANYPRODUCTFORMDATA_ERROR("Error"));
    }
};
//COMPANY Account FLAG   SETCOMPANYPRODUCTFLAG
export const SetEditCompanyAccountFlagAction = (data) => async (dispatch) => {
    dispatch(SETCOMPANYACCOUNTFLAG_SUCCESS(data));
};
//COMPANY Account FORM DATA
export const SetCompanyAccountFormDataAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETCOMPANYACCOUNTFORMDATA_SUCCESS(data));
    } else {
        dispatch(SETCOMPANYACCOUNTFORMDATA_ERROR("Error"));
    }
};

//COMPANY Account and product FORM DATA
export const SetCompanyAccountAndProductFormDataAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETCOMPANYACCOUNTANDPRODUCTFORMDATA_SUCCESS(data));
    } else {
        dispatch(SETCOMPANYACCOUNTANDPRODUCTFORMDATA_ERROR("Error"));
    }
};

//COMPANY USERS FLAG   SETCOMPANYPRODUCTFLAG
export const SetEditCompanyUsersFlagAction = (data) => async (dispatch) => {
    dispatch(SETCOMPANYUSERSFLAG_SUCCESS(data));
};

//COMPANY GROUP FLAG
export const SetEditCompanyGroupFlagAction = (data) => async (dispatch) => {
    dispatch(SETCOMPANYGROUPFLAG_SUCCESS(data));
};

//COMPANY USERS Account and Product FLAG
export const SetEditCompanyUsersAccountAndProductFlagAction = (data) => async (dispatch) => {
    dispatch(SETCOMPANYACCOUNTANDPRODUCTFLAG_SUCCESS(data));
};
//COMPANY USERS FORM DATA
export const SetCompanyUsersFormDataAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETCOMPANYUSERSFORMDATA_SUCCESS(data));
    } else {
        dispatch(SETCOMPANYUSERSFORMDATA_ERROR("Error"));
    }
};

//COMPANY GROUP FORM DATA
export const SetCompanyGroupFormDataAction = (data) => async (dispatch) => {
    if (data) {
        dispatch(SETCOMPANYGROUPFORMDATA_SUCCESS(data));
    } else {
        dispatch(SETCOMPANYGROUPFORMDATA_ERROR("Error"));
    }
};

export const SetAuthMatrixFurtherDetailsToNullAction = () => async (dispatch) => {
    dispatch(SETAUTHMATRIXFURTHERDETAILS_NULL_SUCCESS(null));
};

export const GetParserHeadDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETPARSERHEADDETAILS_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETPARSERHEADDETAILS_ERROR("Error"));
        return res?.responsecode;
    }
};

export const GetParserHeadFurtherDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETPARSERHEADFURTHERDETAILS_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETPARSERHEADFURTHERDETAILS_ERROR("Error"));
        return res?.responsecode;
    }
};

export const SetParserHeadFurtherDetailsAction = (data) => async (dispatch) => {
    dispatch(SETPARSERHEADFURTHERDETAILS_SUCCESS(data));
};
//PARSER HEAD DETAILS ROW
export const SetParserHeadExtremeFurtherDetailsAction = (data) => async (dispatch) => {
    dispatch(SETPARSERHEADFURTHERDETAILSDATA_SUCCESS(data));
};

//Set parser head further details null Success
export const SetParserHeadDetailsToNullAction = () => async (dispatch) => {
    dispatch(SETPARSERHEADFURTHERDETAILS_NULL_SUCCESS(null));
};

// Edit parser head
export const SetEditParserFlagAction = (data) => async (dispatch) => {
    dispatch(SETPARSEREDITFLAG_SUCCESS(data));
};

// Edit parser head Details
export const SetEditParserHeadDetailsFlagAction = (data) => async (dispatch) => {
    dispatch(SETPARSERHEADDETAILSEDITFLAG_SUCCESS(data));
};

//company Product null Success
export const SetCompanyProductFormDataToNullAction = () => async (dispatch) => {
    dispatch(SETCOMPANYPRODUCTFORMDATA_NULL_SUCCESS(null));
};
//company Account null Success
export const SetCompanyAccountFormDataToNullAction = () => async (dispatch) => {
    dispatch(SETCOMPANYACCOUNTFORMDATA_NULL_SUCCESS(null));
};

//company Users null Success
export const SetCompanyUsersFormDataToNullAction = () => async (dispatch) => {
    dispatch(SETCOMPANYUSERSFORMDATA_NULL_SUCCESS(null));
};

//company Group null Success
export const SetCompanyGroupFormDataToNullAction = () => async (dispatch) => {
    dispatch(SETCOMPANYGROUPFORMDATA_NULL_SUCCESS(null));
};

//company Users Account and Product null Success
export const SetCompanyUsersAccountAndProductFormDataToNullAction = () => async (dispatch) => {
    dispatch(SETCOMPANYACCOUNTANDPRODUCTFORMDATA_NULL_SUCCESS(null));
};

//compnay product detail Action
export const GetCompanyProductDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYPRODUCTDETAIL_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYPRODUCTDETAIL_ERROR("Error"));
        return res?.responsecode;
    }
};

//compnay user detail Action
export const GetCompanyUsersDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYUSERSDETAIL_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYUSERSDETAIL_ERROR("Error"));
        return res?.responsecode;
    }
};
//compnay Account detail Action
export const GetCompanyAccountDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYACCOUNTDETAIL_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYACCOUNTDETAIL_ERROR("Error"));
        return res?.responsecode;
    }
};

//compnay Account and Product detail Action
export const GetCompanyAccountAndProductDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYACCOUNTANDPRODUCT_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYACCOUNTANDPRODUCT_ERROR("Error"));
        return res?.responsecode;
    }
};

//company Account and Product detail Action
export const GetCompanyGroupDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYGROUPDETAIL_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYGROUPDETAIL_ERROR("Error"));
        return res?.responsecode;
    }
};
//Get company Account Authorization
export const GetCompanyAccountAuthorizationAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYACCOUNTAUTHORIZATION_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYACCOUNTAUTHORIZATION_ERROR("Error"));
        return res?.responsecode;
    }
};

//compnay parser head link detail Action
export const GetCompanyParserHeadLinkedDetailsAction = (url) => async (dispatch) => {
    const res = await handleGetRequest(url);
    if (res?.responsecode === 1) {
        dispatch(GETCOMPANYPARSERLINKEDHEADDETAILS_SUCCESS(res?.data));
        return res?.responsecode;
    } else {
        dispatch(GETCOMPANYPARSERLINKEDHEADDETAILS_ERROR("Error"));
        return res?.responsecode;
    }
};
